var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1523.84,
    viewBox: "0 0 1080 1523.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.colorS-1{fill:currentFill;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "colorS-1",
    d: "M1080,670.82v216.73c-75.98,47.67-153.84,97.09-230.78,145.92C383.21,1329.28,140.99,1476.96,0,1523.84v-493.27c114.86-157.43,258.7-325.03,388.78-471.77,13.01-14.67,24.02-27.07,32.55-36.82,14.21-16.24,34.51-37.92,58.02-63,48.09-51.3,174.81-186.51,227.98-270.33C545.29,218.51,251.57,378.64,0,530.21v-213.28C246.02,173.81,515.94,35.2,680.81,6.59c110.3-19.12,183.56,3.43,217.9,67.06,60.2,111.62-43.99,253.72-285.18,511.06-22.37,23.88-41.67,44.49-53.8,58.35-8.76,10-20.02,22.7-33.34,37.72-98.05,110.63-363.06,409.56-491.35,628.83,177.6-89.85,490.33-288.36,715.62-431.38,110.49-70.14,222.84-141.46,329.34-207.41Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.f3ba7e6f0f6d941ebfce25461ed5ce56.svg";
export { ForwardRef as ReactComponent };